import axios from "axios"

class LocationService {
	async getLocation(cep) {
		return axios.get(`https://viacep.com.br/ws/${cep}/json/`)
	}
}

export default new LocationService()
